<template>
  <div class="container">
    <sys-dialog
      v-show="dialogVisible"
      :bgi="dialogBgi"
      :show-close="true"
      :error-msg="errorMsg"
      @close="closeDialog"
    />

    <sys-dialog
      v-show="renderDialogVisible"
      :show-close="false"
      :hasNoMaxWidth="true"
      @close="closeDialog"
    >
      <img style="width: 300px;" :src="dialogImg" />
      <div class="dialog-tip">
        <span>Tự động đăng nhập trong</span>
        <span style="color: #C5FB2D">5s</span>
      </div>
    </sys-dialog>

    <sys-dialog
      v-show="dialogLoginVisible"
      :show-close="false"
      :hasNoMaxWidth="true"
      :zIndex="2"
      @close="closeDialogLogin"
    >
      <div :class="isMobile ? 'form-container isMobile' : 'form-container'">
        <img
          class="form-close-img"
          src="../assets/sport5/close-dialog.png"
          @click="closeDialogLogin"
        />

        <div :class="isRegisterAction ? 'form' : 'form login'">
          <div class="tags">
            <span
              :class="isRegisterAction ? 'tag register active' : 'tag register'"
              @click="
                () => {
                  switchTab(true);
                }
              "
            ></span>
            <span
              :class="!isRegisterAction ? 'tag active' : 'tag'"
              @click="
                () => {
                  switchTab(false);
                }
              "
            ></span>
          </div>

          <div class="inputs">
            <div class="form-input">
              <img src="../assets/sport4/icon-username.png" />
              <input
                v-model="form.username"
                placeholder="Tên đăng nhập"
                maxlength="20"
                autocomplete="off"
                @blur="() => onBlur('username')"
                @change="() => onKeyup('username')"
                @keyup="() => onKeyup('username')"
              />
              <span class="errMsg">{{ formErrMsg.username }}</span>
            </div>

            <div
              class="form-input"
              :style="!isRegisterAction ? { marginBottom: 0 } : ''"
            >
              <img src="../assets/sport4/icon-password.png" />
              <input
                v-model="form.password"
                type="password"
                minlength="4"
                maxlength="15"
                autocomplete="new-password"
                placeholder="Mật khẩu"
                @blur="() => onBlur('password')"
              />
              <span class="errMsg">{{ formErrMsg.password }}</span>
              <a
                v-if="!isRegisterAction"
                class="error"
                href="https://www.888b.com"
                >Quên Mật Khẩu?</a
              >
            </div>

            <div class="form-input" v-show="isRegisterAction">
              <img src="../assets/sport4/icon-phone.png" />
              <input
                v-model="form.phone"
                placeholder="Số điện thoại"
                maxlength="11"
                oninput="value=value.replace(/^\D/, '')"
                @blur="() => onBlur('phone')"
              />
              <span class="errMsg">{{ formErrMsg.phone }}</span>
            </div>

            <div
              class="form-input"
              v-show="isRegisterAction"
              style="margin-bottom: 0;"
            >
              <img src="../assets/sport4/icon-email.png" />
              <input
                v-model="form.email"
                autocomplete="off"
                placeholder="Email"
                @blur="() => onBlur('email')"
              />
              <span
                :class="
                  formErrMsg.email && formErrMsg.email.length > 20
                    ? 'errMsg longErrMsg'
                    : 'errMsg'
                "
                >{{ formErrMsg.email }}</span
              >
            </div>

            <v-captcha
              ref="vcaptcha1"
              :dialogVisible="dialogVisible"
              :showCheck="showCheck"
              @cb="handleConfirm"
              :vstyle="
                isMobile
                  ? {
                      width: '50%',
                      height: '18%',
                      position: 'absolute',
                      left: '25%',
                      bottom: '-6%'
                    }
                  : {
                      width: '50%',
                      height: '18%',
                      position: 'absolute',
                      left: '25%',
                      bottom: 0
                    }
              "
              :nativeButton="
                isMobile
                  ? {
                      width: '100%',
                      height: '47px'
                    }
                  : {
                      width: '100%',
                      height: '65px'
                    }
              "
            >
              <div
                v-show="isRegisterAction"
                class="submitBtn reg"
                :style="
                  `background-image: url(${require('../assets/sport5/btn-register.png')});background-size: 100% 100%;`
                "
                @click="submitAction(1)"
              ></div>
            </v-captcha>

            <div
              v-show="!isRegisterAction"
              class="submitBtn login"
              :style="
                `background-image: url(${require('../assets/sport5/btn-login.png')});background-size: 100% 100%;`
              "
              @click="submitAction(2)"
            ></div>

            <div class="bottom-tips" v-if="isRegisterAction">
              <span>Bạn đã có tài khoản ?</span>
              <span style="color: #DAFC0A">Đăng nhập ngay</span>
            </div>
          </div>
        </div>
      </div>
    </sys-dialog>

    <sys-loading :loading="loading" />

    <div :class="isMobile ? 'root' : 'content'">
      <div class="main">
        <a
          class="link-item link-item-facebook"
          href="https://m.me/888BVN"
          target="_blank"
          ><img src="../assets/sport5/facebook.png"
        /></a>

        <a
          class="link-item link-item-telegram"
          href="https://t.me/nhacai888b"
          target="_blank"
          ><img src="../assets/sport5/telegram.png"
        /></a>

        <div class="social-app">
          <a href="https://m.me/888BVN" target="_blank"
            ><img src="../assets/sport5/facebook.png"
          /></a>
          <a href="https://t.me/nhacai888b" target="_blank"
            ><img src="../assets/sport5/telegram.png"
          /></a>
        </div>

        <div class="top-banner">
          <img src="../assets/sport5/logo-title.png" />
        </div>

        <div class="app-middle-content">
          <img class="giai-tri" src="../assets/sport5/middle-center.png" />

          <div class="app-middle-slider">
            <sys-swiper :swiper-images="swiperImages" />
          </div>

          <img
            class="dang-ky-nhan"
            src="../assets/sport5/dang-ky-nhan.png"
            @click="showDialogLogin"
          />
        </div>

        <div class="middle-content">
          <div class="middle-content-left">
            <div style="width: 355px;">
              <sys-swiper :swiper-images="swiperImagesLeft" />
            </div>
          </div>
          <div class="middle-content-center" @click="showDialogLogin">
            <img class="giai-tri" src="../assets/sport5/middle-center.png" />
            <img class="dang-ky-nhan" src="../assets/sport5/dang-ky-nhan.png" />
          </div>
          <div class="middle-content-right">
            <div style="width: 355px;">
              <sys-swiper :swiper-images="swiperImagesRight" />
            </div>
          </div>
        </div>

        <div class="bottom-banner">
          <img src="../assets/sport5/game-bottom.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import {FORM_VALID_MESSAGE, DOMAIN_INVITE_CODE, DOMAIN_AGENT_LINE} from "../utils/constant";
import {userRegister, userLogin, createCustomer, sendEndPoint} from "../utils/request";
import {
  encodePlatformUrl,
  validForm,
  isMobile,
  replacePhonePrefix
} from "../utils/tools";
import { captcha } from "@/mixins/captcha";

const check = {
  //邮箱
  email: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/,
  // 用户名
  username: /^[0-9a-zA-Z]{4,20}$/,
  // 用户密码
  password: /^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/
};

export default {
  name: "Sport",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
      renderDialogVisible: false,
      dialogLoginVisible: false,
      isMobile: isMobile(),
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,

      dialogImg: require("../assets/sport5/register-success-new.png"),
      dialogBgiRegister: require("../assets/sport5/register-success-new.png"),
      dialogBgiLogin: require("../assets/sport5/login-success-new.png"),
      dialogBgi: require("../assets/sport4/bgi-dialog.png"),

      form: {
        by: 1,
        username: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      formErrMsg: {
        username: null,
        password: null,
        phone: null,
        email: null
      },
      errorMsg: {
        title: "",
        content: ""
      },
      closeImage: require("../assets/sport5/close-dialog.png"),
      swiperImages: [
        require("../assets/sport5/swiper-1.png"),
        require("../assets/sport5/swiper-2.png"),
        require("../assets/sport5/swiper-3.png"),
        require("../assets/sport5/swiper-4.png")
      ],
      swiperImagesLeft: [
        require("../assets/sport5/swiper-1.png"),
        require("../assets/sport5/swiper-2.png")
      ],
      swiperImagesRight: [
        require("../assets/sport5/swiper-3.png"),
        require("../assets/sport5/swiper-4.png")
      ]
    };
  },
  mounted() {
    this.swiperMobileVisible = isMobile() && window.innerWidth > 360;
    window.onresize = () => {
      this.isMobile = isMobile();
      this.swiperMobileVisible = this.isMobile && window.innerWidth > 360;
    };
  },
  methods: {
    onKeyup(key) {
      if(key === 'username') {
        this.form.username = this.form.username.replace(/[\W]/g,'')
      }
    },
    switchTab(flag) {
      this.errMsg = {
        username: null,
        password: null,
        phone: null,
        email: null
      };
      this.isRegisterAction = flag;
    },
    onBlur(key) {
      if (key === "username") {
        this.form.username = this.form.username.replace(/[\W]/g,'')
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "4 - 20 ký tự gồm số và chữ";
        } else {
          this.formErrMsg.username = null;
        }
      }

      if (key === "password") {
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
        } else {
          this.formErrMsg.password = null;
        }
      }

      if (key === "phone") {
        const reg = /^\d{10,11}$/;
        if (!this.form.phone) {
          this.formErrMsg.phone = "*Vui lòng nhập số điện thoại";
        } else if (!reg.test(this.form.phone)) {
          this.formErrMsg.phone = "*Số điện thoại không đúng định dạng";
        } else {
          this.formErrMsg.phone = null;
        }
      }

      if (key === "email") {
        if (!this.form.email) {
          this.formErrMsg.email = "*Vui lòng nhập Email";
        } else if (
          !["", null, "null"].includes(this.form.email) &&
          (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(
            this.form.email
          ) ||
            !(
              String(this.form.email)
                .toLowerCase()
                .indexOf("@gmail.com") > -1 ||
              String(this.form.email)
                .toLowerCase()
                .indexOf("@yahoo.com") > -1
            ))
        ) {
          this.formErrMsg.email = "*Chỉ chấp nhận email @gmail.com, @yahoo.com";
        } else {
          this.formErrMsg.email = null;
        }
      }
    },
    closeDialogLogin() {
      this.dialogLoginVisible = false;
    },
    showDialogLogin() {
      this.dialogLoginVisible = true;
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);

      if (type === 1) {
        //  注册校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "4 - 20 ký tự gồm số và chữ";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
        // 手机号
        const reg = /^\d{10,11}$/;
        if (!this.form.phone) {
          this.formErrMsg.phone = "*Vui lòng nhập số điện thoại";
          return;
        } else if (!reg.test(this.form.phone)) {
          this.formErrMsg.phone = "*Số điện thoại không đúng định dạng";
          return;
        }

        // 邮箱
        if (!this.form.email) {
          this.formErrMsg.email = "*Vui lòng nhập Email";
          return;
        } else if (
          !["", null, "null"].includes(this.form.email) &&
          (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(
            this.form.email
          ) ||
            !(
              String(this.form.email)
                .toLowerCase()
                .indexOf("@gmail.com") > -1 ||
              String(this.form.email)
                .toLowerCase()
                .indexOf("@yahoo.com") > -1
            ))
        ) {
          this.formErrMsg.email = "*Chỉ chấp nhận email @gmail.com, @yahoo.com";
          return;
        } else {
          this.formErrMsg.email = null;
        }
      } else if (type === 2) {
        // 登陆校验
        // 用户名
        if (!this.form.username) {
          this.formErrMsg.username = "*Vui lòng nhập tên đăng nhập";
          return;
        } else if (!check.username.test(this.form.username)) {
          this.formErrMsg.username = "4 - 20 ký tự gồm số và chữ";
          return;
        }
        // 密码
        if (!this.form.password) {
          this.formErrMsg.password = "*Vui lòng nhập mật khẩu";
          return;
        } else if (!check.password.test(this.form.password)) {
          this.formErrMsg.password = "*Mật khẩu phải từ 6 đến 15 ký tự";
          return;
        }
      }

      // if (Object.keys(errorMsg).length !== 0) {
      //   this.setDialogMsg(errorMsg.title, errorMsg.content);
      //   return;
      // }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.username,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_INVITE_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.userName = this.form.username;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            this.dialogImg = this.dialogBgiLogin;
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      this.params = Object.assign({}, this.form);
      // let params = (this.params = Object.assign({}, this.form));
      // if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
      //   this.setDialogMsg(
      //     FORM_VALID_MESSAGE.registerFailTitle,
      //     FORM_VALID_MESSAGE.passwordMsg
      //   );
      //   this.loading = false;
      //   return;
      // }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.phone =
        params.phone.length == 10
          ? params.phone
          : replacePhonePrefix(params.phone);
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.dialogLoginVisible = false;
            this.renderDialogVisible = true;
            this.dialogImg = this.dialogBgiRegister;
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                this.form.username,
                this.form.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #ffffff;
}

// 通用文件
.content,
.root {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

// 电脑端
.content {
  background-image: url("../assets/sport5/bgi-pc.png");
  background-size: 100% 100%;

  .main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    justify-content: space-evenly;
    box-sizing: border-box;

    position: relative;
    .app-middle-content {
      display: none;
    }

    .link-item {
      display: none;
    }

    .social-app {
      position: absolute;
      left: 24px;
      top: 20px;
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        cursor: pointer;
      }
    }

    .top-banner {
      display: flex;
      align-items: center;
      img {
        height: 135px;
      }
    }

    .middle-content {
      width: 100%;
      height: 500px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .middle-content-left {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .middle-content-center {
        flex: 3;
        display: flex;
        align-items: center;
        flex-direction: column;
        .giai-tri {
          height: 332px;
        }
        .dang-ky-nhan {
          width: 325px;
          height: 75px;
          margin-top: 20px;
        }
      }
      .middle-content-right {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .bottom-banner {
      img {
        height: 108px;
      }
    }
  }
}

// 手机端
.root {
  height: auto;
  min-height: 100vh;
  background-image: url("../assets/sport5/bgi-h5.png");
  background-size: 100% 100%;
  padding-bottom: 5vh;

  .main {
    display: flex;
    flex-flow: column;
    align-items: center;
    // padding-top: 5vw;
    position: relative;

    .social-app {
      display: none;
    }

    .link-item {
      display: block;
      position: absolute;
      top: 17px;
      &.link-item-telegram {
        right: 17px;
      }
      &.link-item-facebook {
        left: 17px;
      }
      img {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }

    .middle-content {
      display: none;
    }

    .app-middle-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      .giai-tri {
        height: 217px;
      }
      .dang-ky-nhan {
        margin-top: 20px;
        height: 70px;
      }
      .app-middle-slider {
        width: 220px;
      }
    }

    .top-banner {
      display: flex;
      align-items: center;
      img {
        height: 93px;
      }
    }

    .bottom-banner {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      img {
        width: 94%;
      }
    }
  }
}

/deep/ .close-img {
  width: 40px;
  height: 40px;
  opacity: 0;
  top: 40px !important;
  right: 50px !important;
}

@media only screen and (max-width: 767px) {
  /deep/ .moda {
    padding: 20vw !important;
  }

  /deep/ .close-img {
    width: 30px !important;
    height: 30px !important;
    opacity: 0;
    top: 10px !important;
    right: 15px !important;
  }
}

// 注册弹窗
@font-face {
  font-family: "UTMMabella";
  src: url("../assets/font/UTM-Mabella.ttf");
}

.myDialog-enter-active,
.myDialog-leave-active {
  transition: all 0.3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}

.dialog-tip {
  font-size: 18px;
  margin-top: 12px;
  color: #fffcfc;
  font-family: "Montserrat";
  font-weight: 100;
}

.form-container {
  position: relative;
  .form {
    width: 449px;
    height: 425px;
    background-image: url("../assets/sport5/bgi-form.png");
    background-size: 100% 100%;
    background-size: contain;

    &.login {
      background-image: url("../assets/sport5/bgi-form-login.png");
      height: 281px;
      .tags {
        top: -18.8%;
        width: 102%;
      }
      .inputs {
        top: -17.8%;
      }
    }

    .tags {
      width: 100%;
      height: 97px;
      position: relative;
      top: -11.8%;
      display: flex;
      align-items: center;
      justify-content: center;

      .tag {
        width: 35%;
        height: 75%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../assets/sport5/tag-login.png");
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;

        &.register {
          background-image: url("../assets/sport5/tag-regist.png");
        }

        &.active {
          height: 90%;
          width: 55%;
          background-image: url("../assets/sport5/tag-login-active.png");
          &.register {
            background-image: url("../assets/sport5/tag-regist-active.png");
          }
        }
      }
    }

    .inputs {
      top: -11.8%;
      height: 88%;
      position: relative;
      .bottom-tips {
        display: none;
      }
    }

    .form-input {
      width: 70%;
      height: 47px;
      position: relative;
      margin: 0 auto 20px;

      .errMsg {
        font-size: 11px;
        position: absolute;
        left: 59px;
        bottom: -18px;
        color: #f9fe1f;
        &.longErrMsg {
          left: 50%;
          width: 100%;
          transform: translateX(-50%);
        }
      }
      img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
      }

      input {
        width: 100%;
        height: 100%;
        background: transparent url("../assets/sport5/bgi-input.png") no-repeat;
        background-size: 100% 100%;
        border: none;
        outline: none;
        text-indent: 58px;
        font-size: 24px;
        color: #ffffff;
        &::placeholder {
          color: #fbfde8;
          opacity: 0.9;
          font-size: 14px;
          // 这里让浏览器自动去判断
          line-height: normal;
        }
      }
    }

    a.error {
      position: absolute;
      right: 0px;
      bottom: -18px;
      color: #ffffff;
      font-size: 12px;
      text-decoration: none;
      text-align: center;
    }
    .submitBtn {
      margin-top: 20px;
      width: 180px;
      cursor: pointer;
      &.reg {
        height: 55px;
      }

      &.login {
        margin: 20px auto;
        height: 55px;
        bottom: 42px;
      }
    }
  }

  .form-close-img {
    position: absolute;
    top: -39px;
    right: -36px;
    width: 55px;
    height: 55px;
    cursor: pointer;
  }

  &.isMobile {
    .form {
      width: 373px;
      height: 352px;
      display: flex;
      flex-direction: column;
      align-items: center;

      a.error {
        right: -6px;
      }

      .tags {
        margin: 0 auto;
        width: 350px;
        height: 60px;
        top: -7.8%;
        justify-content: space-between;
        .tag {
          width: 150px;
          height: 56px;
        }
        .tag.active {
          width: 227px;
          height: 75px;
        }
      }
      .inputs {
        top: -5.8%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        .form-input {
          height: 38px;
          width: 283px;
          input {
            padding: 0;
            font-size: 16px;
          }
          .errMsg {
            left: 31px;
            &.longErrMsg {
              left: 50%;
            }
          }
        }

        .submitBtn {
          &.reg {
            height: 45px;
          }
          &.login {
            height: 38px;
          }
        }

        .bottom-tips {
          margin-top: 5px;
          display: block;
          // position: absolute;
          // left: 50%;
          // width: 100%;
          // transform: translate(-50%);
          // bottom: 9px;
          font-size: 12px;
        }
      }

      &.login {
        height: 233px;
        .tags {
          top: -10.8%;
          width: 91%;
          padding-left: 20px;
        }
        .submitBtn.login {
          bottom: 40px;
        }
      }
    }
    .form-close-img {
      top: 100%;
      right: 50%;
      transform: translate(50%, 19%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sport5.vue